/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S6_P2Inputs */

const en_guide_json_vs_yaml_xml_s6_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You rarely have to commit to just one. Many teams keep configuration in YAML for readability, convert it to JSON at build time for their tooling, and send data as JSON over the wire. Converting between the three is cheap, so treat the choice as something you make per context rather than once for the whole project.`)
};

const ko_guide_json_vs_yaml_xml_s6_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하나만 고집할 필요는 거의 없습니다. 많은 팀이 가독성을 위해 설정을 YAML로 두고, 빌드 시점에 도구를 위해 JSON으로 변환하며, 데이터는 JSON으로 주고받습니다. 세 형식 간 변환은 비용이 낮으니, 프로젝트 전체를 두고 한 번 정하기보다 상황마다 선택한다고 생각하세요.`)
};

const ja_guide_json_vs_yaml_xml_s6_p2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一つに絞る必要はめったにありません。多くのチームは可読性のために設定を YAML で持ち、ビルド時にツール向けへ JSON に変換し、データは JSON でやり取りします。三つの形式間の変換は安価なので、プロジェクト全体で一度決めるのではなく、状況ごとに選ぶものと考えましょう。`)
};

/**
* | output |
* | --- |
* | "You rarely have to commit to just one. Many teams keep configuration in YAML for readability, convert it to JSON at build time for their tooling, and send da..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S6_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s6_p2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S6_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S6_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s6_p2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s6_p2(inputs)
	return ja_guide_json_vs_yaml_xml_s6_p2(inputs)
});